const contentReview = ()=>import("./views/contentReview.vue");

export default {
  //内容审核
  path: "/contentReview",
  name: "contentReview",
  component: contentReview,
  meta: {
    root: "/inforMan"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/contentReview/router.js